import { Link, useLocation } from "@tanstack/react-router";
import { SITE } from "@/data/site";
import { productApplyHref } from "@/lib/utils";

const HIDE_ON = [/^\/apply/, /^\/thank-you/, /^\/lovable/, /^\/api/];

export function MobileCTABar() {
  const loc = useLocation();
  if (HIDE_ON.some((r) => r.test(loc.pathname))) return null;
  return (
    <div
      className="fixed inset-x-0 bottom-0 z-40 border-t border-border bg-background/95 p-2 shadow-[0_-4px_16px_rgba(0,0,0,0.08)] backdrop-blur lg:hidden"
      role="region"
      aria-label="Quick actions"
    >
      <div className="mx-auto flex max-w-2xl items-stretch gap-2">
        <Link
          to={productApplyHref(loc.pathname)}
          className="flex-1 rounded-md bg-brand-gold px-4 py-3 text-center text-sm font-semibold text-primary shadow-sm"
        >
          Start My Approval
        </Link>
        <a
          href={SITE.phoneHref}
          className="flex-1 rounded-md border border-brand bg-background px-4 py-3 text-center text-sm font-semibold text-brand"
        >
          Call {SITE.phone.replace(/^1-/, "")}
        </a>
      </div>
    </div>
  );
}
